// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top_row {
  width: 100%;
  display: inline-flex;
  padding: 20px 40px;
  background: #fffbf6;
  color: #6b6b6b;
}
.top_row label {
  display: block;
}
.top_row b {
  font-size: 24px;
}
.top_row .vertical_cards_scroller {
  margin-left: 20px;
  display: inline-flex;
  overflow-x: scroll;
  overflow-y: hidden;
  width: 80%;
  grid-gap: 10px;
}
.top_row .vertical_cards_scroller .micro_vert_card img {
  height: 77px;
  max-width: 77px;
  box-shadow: 0px 0px 10px #b1b1b1;
}

.core_content {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
}
.core_content .inner_ctn {
  display: inline-flex;
  width: 100%;
}
.core_content .inner_ctn .stat_indicatior_col {
  width: -moz-fit-content;
  width: fit-content;
  margin: 10px;
  margin-top: 98px;
}
.core_content .inner_ctn .stat_indicatior_col .stat_indicator {
  width: 20px;
  margin-bottom: 8px;
}
.core_content .inner_ctn .stat_indicatior_col .stat_indicator .circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e8e8e8;
  margin: auto;
  display: block;
}
.core_content .inner_ctn .stat_indicatior_col .stat_indicator .line {
  width: 1px;
  height: 80px;
  background: #e8e8e8;
  margin: auto;
  display: block;
  margin-top: 8px;
}
.core_content .inner_ctn .stat_indicatior_col .green .circle,
.core_content .inner_ctn .stat_indicatior_col .green .line {
  background: rgb(163, 203, 163);
}
.core_content .inner_ctn .stat_indicatior_col .green_nl .circle {
  background: rgb(163, 203, 163);
}
.core_content .inner_ctn .stat_content_col {
  width: 85%;
  margin-top: 70px;
  margin-right: 10px;
}
.core_content .inner_ctn .stat_content_col .stat_content {
  width: 100%;
  background: #fff;
  padding: 16px;
  padding-left: 12px;
  border-radius: 6px;
  margin-bottom: 35px;
  color: rgb(73, 73, 73);
  font-weight: 900;
}
.core_content .inner_ctn .stat_content_col .stat_content span {
  font-size: 12px;
  color: #8e8e8e;
  display: block;
}
.core_content .inner_ctn .stat_content_col .stat_content .track_row {
  font-size: 12px;
  margin: 6px 0px;
}
.core_content .inner_ctn .stat_content_col .stat_content .track_row a {
  color: #737373;
  text-decoration: underline;
}
.core_content .btm_btns {
  width: 100%;
  background: #fefefe;
  padding: 10px;
  background: none;
  padding: 10px;
  display: block;
  text-align: center;
}
.core_content .btm_btns ion-button {
  border: 1px solid #dddcdb;
  color: #9a9896;
  font-weight: bold;
  margin: auto;
  padding: 4px 40px;
  background: g;
  font-size: 12px;
  border-radius: 4px;
  margin-bottom: 10px;
}
.core_content .btm_btns ion-button ion-icon {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/order-tracker/order-tracker.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACI;EACI,cAAA;AACR;AAEI;EACI,eAAA;AAAR;AAGI;EACI,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AADR;AAIY;EACI,YAAA;EACA,eAAA;EACA,gCAAA;AAFhB;;AAQA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AALJ;AAOI;EACI,oBAAA;EACA,WAAA;AALR;AAOQ;EACI,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,gBAAA;AALZ;AAOY;EACI,WAAA;EACA,kBAAA;AALhB;AAOgB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AALpB;AAQgB;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AANpB;AAWgB;;EAEI,8BAAA;AATpB;AAaY;EACI,8BAAA;AAXhB;AAeQ;EACI,UAAA;EACA,gBAAA;EACA,kBAAA;AAbZ;AAeY;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAbhB;AAegB;EACI,eAAA;EACA,cAAA;EACA,cAAA;AAbpB;AAgBgB;EACI,eAAA;EACA,eAAA;AAdpB;AAgBoB;EACI,cAAA;EACA,0BAAA;AAdxB;AAqBI;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAnBR;AAqBQ;EACI,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAnBZ;AAqBY;EACI,eAAA;AAnBhB","sourcesContent":[".top_row {\n    width: 100%;\n    display: inline-flex;\n    padding: 20px 40px;\n    background: #fffbf6;\n    color: #6b6b6b;\n\n    label {\n        display: block;\n    }\n\n    b {\n        font-size: 24px;\n    }\n\n    .vertical_cards_scroller {\n        margin-left: 20px;\n        display: inline-flex;\n        overflow-x: scroll;\n        overflow-y: hidden;\n        width: 80%;\n        grid-gap: 10px;\n\n        .micro_vert_card {\n            img {\n                height: 77px;\n                max-width: 77px;\n                box-shadow: 0px 0px 10px #b1b1b1;\n            }\n        }\n    }\n}\n\n.core_content {\n    width: 100%;\n    height: 100%;\n    background: #f6f6f6;\n\n    .inner_ctn {\n        display: inline-flex;\n        width: 100%;\n\n        .stat_indicatior_col {\n            width: fit-content;\n            margin: 10px;\n            margin-top: 98px;\n\n            .stat_indicator {\n                width: 20px;\n                margin-bottom: 8px;\n\n                .circle {\n                    width: 8px;\n                    height: 8px;\n                    border-radius: 50%;\n                    background: #e8e8e8;\n                    margin: auto;\n                    display: block;\n                }\n\n                .line {\n                    width: 1px;\n                    height: 80px;\n                    background: #e8e8e8;\n                    margin: auto;\n                    display: block;\n                    margin-top: 8px;\n                }\n            }\n\n            .green {\n                .circle,\n                .line {\n                    background: rgb(163, 203, 163);\n                }\n            }\n\n            .green_nl .circle {\n                background: rgb(163, 203, 163);\n            }\n        }\n\n        .stat_content_col {\n            width: 85%;\n            margin-top: 70px;\n            margin-right: 10px;\n\n            .stat_content {\n                width: 100%;\n                background: #fff;\n                padding: 16px;\n                padding-left: 12px;\n                border-radius: 6px;\n                margin-bottom: 35px;\n                color: rgb(73, 73, 73);\n                font-weight: 900;\n\n                span {\n                    font-size: 12px;\n                    color: #8e8e8e;\n                    display: block;\n                }\n\n                .track_row {\n                    font-size: 12px;\n                    margin: 6px 0px;\n\n                    a {\n                        color: #737373;\n                        text-decoration: underline;\n                    }\n                }\n            }\n        }\n    }\n\n    .btm_btns {\n        width: 100%;\n        background: #fefefe;\n        padding: 10px;\n        background: none;\n        padding: 10px;\n        display: block;\n        text-align: center;\n\n        ion-button {\n            border: 1px solid #dddcdb;\n            color: #9a9896;\n            font-weight: bold;\n            margin: auto;\n            padding: 4px 40px;\n            background: g;\n            font-size: 12px;\n            border-radius: 4px;\n            margin-bottom: 10px;\n\n            ion-icon {\n                font-size: 10px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
